import { useMemo } from 'react';

import type { Portfolio } from '@/hooks/usePortfolio';

import type { Datum } from '../types';

import { OTHERS_LABEL, OTHERS_THRESHOLD } from '../constants';

export const usePortfolioDiversificationAcrossHoldings = (
  holdings: Portfolio['holdings']
): { data: Datum[]; others: Datum[] } => {
  return useMemo(() => {
    const data = holdings
      .map((n) => {
        return {
          label: n.symbol,
          currencyISO: n.currencyISO,
          allocation: n.analysis.allocation,
          return7d: n.analysis.return7d,
          return1y: n.analysis.return1y,
          value: n.analysis.value,
        };
      })
      .slice(0)
      .sort((a, b) => (a.allocation > b.allocation ? -1 : 1));

    const top = data.filter((n) => n.allocation > OTHERS_THRESHOLD);
    const bottom = data.filter((n) => n.allocation <= OTHERS_THRESHOLD);
    const summedOthersAllocation = bottom.reduce((a, b) => a + b.allocation, 0);

    if (summedOthersAllocation === 0) {
      return {
        data: top,
        others: [],
      };
    }

    return {
      data: [
        ...top,
        {
          label: OTHERS_LABEL,
          currencyISO: 'USD',
          allocation: summedOthersAllocation,
          value: 0,
          return1y: null,
          return7d: null,
        },
      ],
      others: bottom,
    };
  }, [holdings]);
};
